<template>
  <div class="industry-list-content">
    <div class="industry-title"><i class="icon-img icon-cuo" @click="goBack()"></i>行业分类</div>
    <div class="industry-list">
      <template v-if="industryList&&industryList.length">
        <div @click="industryFun(0,-1)">
          <div>
            <h3>全部行业</h3>
            <p>All Industries</p>
          </div>
        </div>
        <template v-for="(list,index) in industryList">
          <template v-if="parameter.cityId!=1||parameter.cityId==1&&(list.id==3||list.id==10||list.id==7)">
            <div @click="industryFun(list.id,index)" :key="'industryList'+index">
              <div>
                <h3>{{list.name}}</h3>
                <p>{{list.ename}}</p>
              </div>
            </div>
          </template>
        </template>
      </template>
      <div class="industry-list-map" @click="goMap">
        <h3><span class="icon-img icon-map"></span>进入地图</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'phoneIndustryList',
  props: ['currentPageBool'],
  data () {
    return {
      industryList: [],
      parameter: {
        cityId: 0,
        cityIndex: -1,
        countyIndex: -1,
        topIndex: -1,
        typeId: 0
      }
    }
  },
  components: {},
  mounted () {
    let that = this
    that.parameter = that.publicJs.decodeFun(that.$route.query);
  },
  created () {
    this.httpData()
  },
  methods: {
    httpData: function () {
      let that = this
      that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          that.industryList = data.data
        }
      })
    },
    industryFun: function (typeId, index) {
      let that = this
      if (that.currentPageBool) {
        that.$emit('industryBool', index >= 0 ? that.industryList[index] : {'name': '全部行业', id: 0})
      } else {
        that.$emit('industryBool', false)
        that.$router.push({
          path: '/phoneIndustryIndex',
          query: {
            key: that.publicJs.encode(JSON.stringify({
              topIndex: index,
              cityIndex: that.parameter.cityIndex,
              countyIndex: that.parameter.countyIndex,
              cityId: that.parameter.cityId,
              typeId: typeId
            })),
            '_': new Date().getTime()
          }
        })
      }
    },
    goMap: function () {
      let that = this
      that.$router.push({
        path: '/phoneMapIndex',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            topIndex: -1,
            cityIndex: that.parameter.cityIndex,
            countyIndex: that.parameter.countyIndex,
            cityId: that.parameter.cityId,
            typeId: 0
          })),
          '_': new Date().getTime()
        }
      })
    },
    goBack: function () {
      this.$emit('industryBool', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .industry-list-content{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    background-color: #F2F2F2;
    z-index: 7;
  }
  .industry-title{
    border-bottom:1px solid #DDDDDD;
    font-size: 17px;
    color: #333333;
    position: relative;
    padding: 13px 0 13px 41px;
    line-height: 1;
  }
  .icon-cuo{
    position: absolute;
    left: 11px;
    top:50%;
    margin-top: -9px;
  }
  .industry-list{
    padding:0 35px;
  }
  .industry-list>div{
    border-bottom:1px solid #DDDDDD;
    padding: 10px 0;
    cursor: pointer;
  }
  h3{
    font-size: 15px;
    font-weight: bold;
    color: #333333;
  }
  p{
    font-size: 9px;
    color: #999999;
    text-transform: capitalize;
  }
  .industry-list-map{
    border-bottom: none;
  }
  .industry-list-map h3{
    padding-left: 32px;
    position: relative;
  }
  .icon-map{
    width: 26px;
    height: 26px;
    background-position: -60px -244px;
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Phone/industryList.vue